import { Checkbox } from "pretty-checkbox-react";
import { DashboardUtils, RevertDescriptor } from "../../../dashboard_utils";
import classNames from "classnames";
import { useState } from "react";
import { AccordianRevertButton } from "./accordian_revert_button";

export function SeshAccordianComponent(props: {
	is_opened: boolean;
	setIsOpened?: (val: boolean) => void;

	label: string;
	disabled?: boolean;
	info: string | JSX.Element;
	children?: React.ReactNode;
	onChange?: (isOpened: boolean) => void;

	is_unsaved?: boolean;
	is_new?: boolean;
	is_beta?: boolean;
	is_loading?: boolean;
	is_channel_override_active?: boolean;

	does_server_have_premium?: boolean;
	does_require_premium?: boolean;
	revert_descriptor?: RevertDescriptor<any>;

	closed_element?: React.ReactNode;
}) {
	const { is_opened, setIsOpened } = props;

	const checkbox = (
		<span
			// className={`checkbox-wrapper${
			// 	props.should_hide_checkbox ? ` is-invisible` : ""
			// }`}
			className={classNames("checkbox-wrapper")}
		>
			<Checkbox
				className="title-checkbox"
				checked={is_opened}
				onChange={(e) => {
					setIsOpened?.(e.target.checked);
					props.onChange?.(e.target.checked);
				}}
				disabled={props.disabled}
			/>
		</span>
	);

	const child_element = props.is_loading
		? DashboardUtils.RenderLoadingThrobber()
		: props.children;

	return (
		<div
			className={classNames("field", {
				"expanded-collapsible": is_opened,
				"overridden-field": props.is_channel_override_active,
			})}
		>
			<div>
				{DashboardUtils.CreateHeaderAndInfoButton(
					props.label,
					props.info,
					props.does_require_premium &&
						!props.does_server_have_premium,
					props.is_beta,
					props.is_unsaved,
					checkbox,
					props.disabled,
					props.is_new,
					props.revert_descriptor
				)}
				{is_opened ? child_element : props.closed_element}
			</div>
		</div>
	);
}
